import { useTranslation } from 'react-i18next'

import { fieldPicker } from './FormFieldCreator'
import { FieldConfig, inputTypes } from './types'

interface ManualFlowProps {
  fields: FieldConfig
  afterAi?: boolean
}

const ManualFlow = ({ fields, afterAi }: ManualFlowProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      {fieldPicker({
        ...fields.productGroup,
        title: t('defect.field.defectCode'),
        key: 'productGroup',
        type: inputTypes.auto,
      })}
      {fieldPicker({
        ...fields.defectType,
        title: t('defect.field.defectType'),
        key: 'defectType',
        type: inputTypes.auto,
      })}
      {!!fields.positionInVehicle.options.length &&
        fieldPicker({
          ...fields.positionInVehicle,
          title: t('defect.field.locationInfo'),
          key: 'positionInVehicle',
          type: inputTypes.auto,
        })}
      {!afterAi &&
        fieldPicker({
          ...fields.affectToUsage,
          title: t('defect.field.affectToUsage'),
          key: 'affectToUsage',
          type: inputTypes.auto,
        })}
      {!!fields.restrictionCode.options.length &&
        fieldPicker({
          ...fields.restrictionCode,
          title: t('defect.field.serviceRestrictionCode'),
          key: 'restrictionCode',
          type: inputTypes.auto,
        })}

      {fieldPicker({
        ...fields.comment,
        title: t('defect.field.comment'),
        key: 'comment',
        type: inputTypes.input,
      })}
      {fieldPicker({
        title: t('defect.field.attachments'),
        key: 'digitalAssetUuids',
        type: inputTypes.upload,
        instructions: t('defect.attachmentInstructions'),
        onChange: fields.digitalAssetUuids.onChange,
        fileWord: t('defect.attachmentFiles'),
        required: fields.digitalAssetUuids.required,
        files: fields.digitalAssetUuids.files,
        status: fields.digitalAssetUuids.status,
      })}
    </>
  )
}

export default ManualFlow
